"use client";
import { useEffect, useState } from "react";
import { CloseOutlined, MenuOutlined } from "@ant-design/icons"; // Import Ant Design Icons
import { Drawer } from "antd"; // Import Ant Design Drawer
import { Dropdown } from "antd";
import BrandLogo from "./BrandLogo";
import { Link } from "react-router-dom";
interface NavbarProps {

  progressPerc: number;
  step?: number;         // current step (optional, for flexibility)
  totalSteps?: number;
  stepName?: string;
  button?:any;
}
const Navbar: React.FC<NavbarProps> = ({ progressPerc, step, totalSteps, stepName,button }) => {

  const [position, setPosition] = useState(0);
  const [hideHeader, setHideHeader] = useState(true);




  useEffect(() => {
    const handleScroll = () => {
      let moving = window.pageYOffset;
      if (moving > 100) {
        setHideHeader(position > moving);
      } else {
        setHideHeader(true);
      }
      setPosition(moving);
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  });






  return (
    <div className="flex flex-col bg-white w-full ">
      <div
        className={` fixed top-[0] left-[0] z-[79]   transition-all duration-500 
      ease-in-out mx-w-[390px] h-[58px] md:h-[60px] bg-white  flex 
      justify-between items-center w-full md:max-w-[100%] md:min-w-[320px] px-[16px] py-[12px] font-sans shadow-sm`}
      >
        {/* Logo Section */}
      <div className="flex flex-row items-between justify-between">  <Link
          to="/homepage_partner"
          className="flex  justify-center items-center py-3"
        >
          <BrandLogo />

        </Link>{button?button:<></>}
        </div>

        <div
  className="absolute bottom-0 left-0 border-b-[5px] border-blue-500 transition-all duration-300 ease-in-out"
  style={{ width: `${progressPerc}%`, height: 5 }}
></div>



 {/* Sticky subheader (mobile only) */}
 {!hideHeader && stepName && (
        <div className="md:hidden fixed top-[57px] left-0 z-[77] bg-white px-4 py-[15px] flex items-center justify-between w-full text-[#1d2939]
        text-sm font-medium font-['Inter'] leading-tight shadow-sm">
          <p >{stepName}</p>
          <p >{step}/{totalSteps}</p>
        </div>
      )}

        

      </div>
      
     
    </div>
  );
};


export default Navbar;
